import axios from 'axios'
import store from '@store'
import { getToken } from '@utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url
  timeout: 5000, // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (store.state.user.token) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    // code为非20000是抛错 可结合自己业务进行修改
    const res = response.data
    if (res.code && res.code !== 0) {
      if (
        [
          -1,
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          11,
          12,
          13,
          14,
          10001,
          40007,
          40001,
          40002,
          40003,
        ].includes(res.code)
      ) {
        if (!response.config.url.includes('/weixin/task')) {
          store.commit('setMsgBox', {
            visible: true,
            message: res.message,
          })
        } else {
          console.log(res.message)
        }
      }
      return response.data
    } else {
      return response.data
    }
  },
  error => {
    // console.log('err: ', error.response)// for debug
    const res = error.response.data || error.response

    /**
     * 50001: 非法的 token;
     * 50008: 错误的 token
     * 50013: 其他客户端登录了;
     * 50014: Token 过期了;
     * 50015: 签名不匹配
     */
    if ([50001, 50008, 50013, 50001, 50014, 50015].includes(res.code)) {
      store.commit('setMsgBox', {
        visible: true,
        // title: res.error,
        message: '密钥超时，或者当前账号在其他终端登陆，请重新登录。',
        onClose: logOut,
        onConfirm: logOut,
      })
    }
    // if (
    //   res.code === 500 ||
    //   error.response.status === 500 ||
    //   res.status === 500
    // ) {
    //   store.commit('setMsgBox', {
    //     visible: true,
    //     message: '服务器错误：500',
    //   })
    // }
    return Promise.reject(error)
  }
)

function logOut() {
  store.dispatch('FedLogOut').then(() => {
    location.reload() // 为了重新实例化vue-router对象 避免bug
    // this.$router.push({path: '/login'})
  })
}

export default service
